import { Link, useNavigate } from "react-router-dom";
import { BiEdit } from "react-icons/bi";

const MergedOrders = ({
  orders,
  selectedItems,
  handleButtonClick,
  genrateInvoiceModal,
  selectItems,
  location,
  handleDeliverButton,
  setOpenMarkedGenerated,
}) => {
  const navigate = useNavigate();

  if (orders.merged.length === 0) return null;

  const filterOrders = orders.merged.filter((order) =>
    selectedItems.splitId.includes(order.merge_id)
  );
  const hasGeneratedInvoice = filterOrders.every(
    (order) => order?.invoice_generated === 1
  );
  const generateInvoice =
    !hasGeneratedInvoice &&
    filterOrders.some(
      (order) => order?.dispatch_status === 1 && order?.invoice_generated !== 1
    );
  const dispatch = filterOrders.some((order) => order?.dispatch_status === 0);
  const deliver = filterOrders.some(
    (order) => order?.dispatch_status === 1 && order?.delivered_status === 0
  );

  function formatDate(inputDate) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const date = new Date(inputDate);
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day} ${month} ${year}`;
  }

  return (
    <div className="flex">
      <div className="caret">
        <div className="splited-items">
          <div className="order-heading">
            <p className="order-heading-text">#Merged Orders</p>
            <div>
              {dispatch && (
                <button
                  onClick={(event) =>
                    handleButtonClick(event, orders.merged, "dispatch")
                  }
                  className="btn btn-success ml-1 deliver-css"
                >
                  Dispatch
                </button>
              )}
              {generateInvoice && !dispatch && (
                <button
                  onClick={() =>
                    setOpenMarkedGenerated({
                      orders: orders.splited,
                      selectedItems,
                    })
                  }
                  className="btn btn-success ml-1"
                >
                  Marked as Generated
                </button>
              )}
              {generateInvoice && !dispatch && (
                <button
                  onClick={() =>
                    genrateInvoiceModal({
                      orders: orders.splited,
                      selectedItems,
                    })
                  }
                  className="btn btn-default btn-sm ml-1 download-invoice"
                >
                  Generate Invoice
                </button>
              )}
              {deliver && (
                <button
                  onClick={(event) =>
                    handleButtonClick(event, orders.merged, "deliver")
                  }
                  className="btn btn-success ml-1 deliver-css"
                >
                  Delivered
                </button>
              )}
            </div>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Order No</th>
                  <th>Dealer Name</th>
                  <th>Order Date</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {orders.merged.map((order) => (
                  <tr
                    key={`${location}-${order.name}-${Math.random() * 100 + 1}`}
                  >
                    <td>
                      <input
                        type="checkbox"
                        onChange={(event) =>
                          selectItems(
                            event,
                            order.merge_id,
                            location,
                            order.order_id,
                            "merge"
                          )
                        }
                        className={`select-merge select-merge-checked-${order.order_id}`}
                        name="select-merger"
                        disabled={order.invoice_generated === 1}
                        checked={selectedItems.splitId.includes(order.merge_id)}
                      />
                    </td>
                    <td>
                      <Link to={`/admin/dispatch/view/merge/${order.merge_id}`}>
                        #{order.order_no}
                      </Link>
                    </td>
                    <td>{order.name}</td>
                    <td>{formatDate(order.order_date)}</td>
                    <td>
                      {order?.dispatch_status === 0 && (
                        <span className="tag tag-warning">Pending</span>
                      )}
                      {order?.dispatch_status === 1 &&
                        order?.delivered_status === 0 && (
                          <span
                            className="tag tag-success"
                            style={{ background: "#e08b3d", color: "white" }}
                          >
                            Dispatched
                          </span>
                        )}
                      {order?.dispatch_status === 1 &&
                        order?.delivered_status === 1 && (
                          <span
                            className="tag tag-default"
                            style={{ background: "#50ae31", color: "white" }}
                          >
                            Delivered
                          </span>
                        )}
                    </td>
                    <td>
                      {order?.dispatch_status === 0 && (
                        <button
                          className="btn btn-success ml-1"
                          style={{ width: "auto" }}
                          onClick={() =>
                            navigate(
                              `/admin/dispatch/edit/${null}/${order.merge_id}`
                            )
                          }
                        >
                          Transporter <BiEdit size={18} />
                        </button>
                      )}
                      {order.invoice_generated === 1 &&
                        order.delivered_status !== 1 && (
                          <button
                            className="btn btn-success ml-1"
                            onClick={(e) =>
                              handleDeliverButton(
                                e,
                                order.order_id,
                                null,
                                order.merge_id
                              )
                            }
                          >
                            Delivered
                          </button>
                        )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MergedOrders;
